import { render, staticRenderFns } from "./Search-Bar.vue?vue&type=template&id=64b43884&lang=pug"
import script from "./Search-Bar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Search-Bar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Search-Bar.vue?vue&type=style&index=0&id=64b43884&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports